import { useTableFilter } from '@welbe/web-design-system';
import { BrokersContext } from 'contexts/Brokers/Brokers';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import { useWindowSize } from 'hooks/useWindowSize';
import { useContext, useEffect, useState } from 'react';
import { getFiles } from './services';

export const useFiles = () => {
	const { height } = useWindowSize();
	const { isBroker } = useContext(BrokersContext);
	const [isFilterOpen, setFilterOpen] = useState<boolean>(true);
	const [categories, setCategories] = useState<any[]>([]);

	useAnalyticsOpenScreen({
		context: 'documents',
		trackName: 'Open List of Documents',
		analyticProps: { isBroker },
	});

	const {
		data,
		loading,
		totalPages,
		currentPage,
		handleSearch,
		handleFilters,
	} = useTableFilter({
		service: getFiles,
		instantSearch: ['category'],
		tableFilters: {
			name: '',
			pageSize: 50,
			pageNumber: 0,
			category: '',
		},
	});

	useEffect(() => {
		if (categories.length === 0 && data?.files?.length > 0) {
			const uniqueCategories = Array.from(
				new Set(data.files.map((file: any) => file.category)),
			).map((category) => ({
				id: category,
				value: category,
			}));

			setCategories([{ id: '', value: '' }, ...uniqueCategories]);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [data]);

	return {
		height,
		isFilterOpen,
		setFilterOpen,
		data,
		loading,
		totalPages,
		currentPage,
		handleSearch,
		handleFilters,
		categories,
	};
};
